import type { SearchResponse } from '@ledokol/contracts'
import { api } from './client'

export async function searchGlobal(q: string): Promise<SearchResponse> {
  const r = await api.get<SearchResponse>('/search', { params: { q } })
  return r.data
}
